import _Object$values from "@babel/runtime-corejs2/core-js/object/values";
import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _Object$freeze from "@babel/runtime-corejs2/core-js/object/freeze";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Gravatar from 'react-gravatar';
import { Icon } from '../../../';
var SIZES = {
  small: 'small',
  large: 'large'
};

var sizeEnum = _Object$freeze({
  small: 40,
  large: 130
});

var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);

  var _super = _createSuper(_default);

  function _default() {
    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      error: false
    });

    _defineProperty(_assertThisInitialized(_this), "onLoad", function () {
      _this.setState({
        loading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      _this.setState({
        error: true
      });
    });

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.email !== this.props.email) {
        this.setState({
          error: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          email = _this$props.email,
          size = _this$props.size,
          userName = _this$props.userName,
          withInitials = _this$props.withInitials;
      var _this$state = this.state,
          loading = _this$state.loading,
          error = _this$state.error;
      var initials = getInitials(userName, email);
      var sizeClassname = "avatar-".concat(size, " ").concat(withInitials ? 'initials' : 'icon');
      return /*#__PURE__*/React.createElement("div", {
        className: classNames('avatar', sizeClassname)
      }, (loading || error) && /*#__PURE__*/React.createElement("div", {
        className: classNames('default', sizeClassname)
      }, !withInitials ? /*#__PURE__*/React.createElement("div", {
        className: "profile-icon"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "user"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "avatar-default"
      }, /*#__PURE__*/React.createElement("div", {
        className: "avatar-title"
      }, "".concat(initials)))), !error && /*#__PURE__*/React.createElement(Gravatar, {
        className: classNames({
          loading: loading
        }),
        email: email,
        "default": "404",
        size: sizeEnum[size] || sizeEnum[SIZES.small],
        onLoad: this.onLoad,
        onError: this.onError
      }));
    }
  }]);

  return _default;
}(React.Component);

_defineProperty(_default, "propTypes", {
  email: PropTypes.string.isRequired,
  size: PropTypes.oneOf(_Object$values(SIZES)),
  userName: PropTypes.string,
  withInitials: PropTypes.bool
});

_defineProperty(_default, "defaultProps", {
  size: SIZES.small
});

export { _default as default };

function getInitials(userName, email) {
  var initials = userName ? userName : email;
  return initials.split(' ').map(function (n) {
    return n[0];
  }).join('').toUpperCase();
}